(() => {
  angular
    .module('gm.common.services')
    .factory('GmyApp', GmyApp);

  function GmyApp(
    $q,
    $log,
    GmyLocation,
    btgUser,
    GmyStorage,
    GmyCurrencies
  ) {
    'ngInject';

    let activeLoadPromise = null;

    return {
      load,
    };

    function load() {
      if (!activeLoadPromise) {
        activeLoadPromise = loadApp();
      }

      return activeLoadPromise;
    }

    function loadApp() {
      const loadPromise = $q.defer();
      const promises = [];

      let currency;

      if (GmyStorage.getSessionItem('website.selected.currency')) {
        currency = angular.fromJson(
          GmyStorage.getSessionItem('website.selected.currency')
        );
        GmyCurrencies.setTempLivePriceCurrency(currency);
      } else {
        currency = GmyCurrencies.getTempLivePriceCurrency();

        GmyStorage.setSessionItem(
          'website.selected.currency',
          angular.toJson(currency)
        );
      }

      promises.push(GmyLocation.load());
      if (btgUser.isNeedToRestore()) {
        promises.push(btgUser.restore());
      }

      $q.all(promises)
        .catch((error) => {
          $log.error('Application failed to load', error);
          loadPromise.resolve();
        })
        .finally(() => {
          loadPromise.resolve();
        });

      return loadPromise.promise;
    }
  }
})();
